import { Box } from "@mui/material";
import Link from "./Link";
import Navbar from "./components/GuestExperience/NavBar";
import RSAdminNavBar from "./components/RSAdmin/RSAdminNavBar";

export type ScaffoldProps = {
  navBar?: boolean;
  center?: boolean;
  rsAdmin?: boolean;
  backLink?: {
    text: string;
    onClick: () => void;
  };
  children: any;
};

const renderNavBar = (navBar?: boolean, rsAdmin?: boolean) => {
  if (!navBar) {
    return null;
  }
  return rsAdmin ? <RSAdminNavBar /> : <Navbar />;
};

export const Scaffold = ({
  navBar,
  center,
  backLink,
  rsAdmin,
  children,
  ...rest
}: ScaffoldProps) => {
  const backLinkSx = center
    ? { display: "flex", justifyContent: "left" }
    : { display: "flex", justifyContent: "center" };

  const contentBoxSx = center
    ? { display: "flex", justifyContent: "center", alignItems: "center" }
    : { display: "flex" };

  // Non-center variant adds an 80px padding prop to the content Box.
  const contentBoxExtraProps = center ? {} : { padding: "80px" };

  return (
    <Box>
      {renderNavBar(navBar, rsAdmin)}
      <Box sx={backLinkSx}>
        {backLink && (
          <Link
            color="#000"
            {...backLink}
          />
        )}
      </Box>
      <Box
        sx={contentBoxSx}
        minHeight={backLink ? "calc(100vh - 64px)" : "80vh"}
        maxWidth={"2000px"}
        {...contentBoxExtraProps}
        {...rest}
      >
        <Box>{children}</Box>
      </Box>
    </Box>
  );
};
